/**
 * Giỗ (Death Anniversary) Types - Feature A3
 * Checklist and helper types for Giỗ events
 */

import { EventType } from './eventTypes';

/**
 * Checklist item for Giỗ preparation
 */
export interface GioChecklistItem {
    id: string;
    label: string;
    checked: boolean;
    isCustom?: boolean;
}

/**
 * Default checklist items for Giỗ preparation
 */
export const DEFAULT_GIO_CHECKLIST: GioChecklistItem[] = [
    { id: 'mam_co', label: 'Mâm cỗ', checked: false },
    { id: 'huong_den', label: 'Hương đèn', checked: false },
    { id: 'vang_ma', label: 'Vàng mã', checked: false },
    { id: 'hoa_qua', label: 'Hoa quả', checked: false },
    { id: 'nen', label: 'Nến', checked: false },
    { id: 'trau_cau', label: 'Trầu cau', checked: false },
    { id: 'ruou', label: 'Rượu', checked: false },
    { id: 'banh_keo', label: 'Bánh kẹo', checked: false },
];

/**
 * Calculate năm thứ X (anniversary year number)
 * @param deathYear - Year of death
 * @param currentYear - Current year (optional, defaults to now)
 * @returns Anniversary year number (1-indexed)
 */
export const calculateGioYearNumber = (
    deathYear: number | string | undefined,
    currentYear?: number
): number | null => {
    if (!deathYear) return null;

    const death = typeof deathYear === 'string' ? parseInt(deathYear, 10) : deathYear;
    if (isNaN(death)) return null;

    const current = currentYear || new Date().getFullYear();
    const yearDiff = current - death;

    // Return null if the death year is in the future
    if (yearDiff < 0) return null;

    // Year 0 = năm thứ 1 (first anniversary)
    return yearDiff + 1;
};

/**
 * Format năm thứ X display text
 */
export const formatGioYearText = (yearNumber: number | null): string | null => {
    if (!yearNumber) return null;
    return `Năm thứ ${yearNumber}`;
};

/**
 * Get checklist progress
 */
export const getChecklistProgress = (
    checklist: GioChecklistItem[]
): { completed: number; total: number; percentage: number } => {
    const total = checklist.length;
    const completed = checklist.filter(item => item.checked).length;
    const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

    return { completed, total, percentage };
};

/**
 * Check if event type is Giỗ
 */
export const isGioEvent = (eventType?: string): boolean => {
    return eventType === EventType.GIO;
};
